<script lang="ts" setup>
    const props = defineProps<{ blok: PageComponentStoryblok }>();

    const { lang } = useLanguage();

    const canonicalUrlAbsolute = useCanonicalUrl(props.blok?.canonicalLink);

    useHead(() => ({
        htmlAttrs: { lang: lang.value },
        link: [{ rel: 'canonical', href: canonicalUrlAbsolute.value }]
    }));

    useControlHeroStrip(Boolean(props.blok?.disableHeaderStrip));
    useControlHeaderBgColor(props.blok?.headerBgColor || 'default');
</script>

<template>
    <div v-editable="props.blok">
        <StickyWrapper />
        <StoryblokComponentWrapper
            v-for="item in props.blok?.header"
            :key="item._uid"
            :blok="item"
        />

        <StoryblokComponentWrapper
            v-for="item in props.blok?.body"
            :key="item._uid"
            :blok="item"
        />
    </div>
</template>
